module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/dc8cb58ef0a7e70cf3ed030c3621013e.png";